<div [ngClass]="{ 'mb-10': images.length, 'mb-20': !images.length }" class="d-flex justify-content-between">
    <label>{{ "widget_product_image_label" | translate }}</label>
    <sp-file-manager [multiSelect]="true" (setFileEvent)="addImage($event)">
        <sp-link-upload-button
            class="custom-link"
            stockImagesDropdown
            (unsplashRequested)="openUnsplashModal()"
            [disabled]="buttonDisabled"
            [label]="'widget_product_add_image'"
        ></sp-link-upload-button>
    </sp-file-manager>
</div>
@if (images.length) {
    <div class="d-flex flex-wrap" [sortablejs]="sortableImages" [sortablejsOptions]="sortableOptions">
        @for (image of images.value; track image; let i = $index) {
            <div class="image-container">
                <picture class="image-wrapper" [spFallbackImg]="formatImageURL(image)">
                    <source [srcset]="formatImageURLWithResize(image)" />
                    <img [src]="formatImageURL(image)" [alt]="i" />
                </picture>
                <a (click)="deleteImage(i)">⨉</a>
            </div>
        }
    </div>
    <p class="help-block small text-muted mb-20">
        <span class="sp-icon icon-info-bold"> </span>
        {{ "widget_product_default_image_hint" | translate }}
    </p>
}
